import { render, staticRenderFns } from "./NewIndicator.vue?vue&type=template&id=ae43c43c&scoped=true&"
import script from "./NewIndicator.vue?vue&type=script&lang=ts&"
export * from "./NewIndicator.vue?vue&type=script&lang=ts&"
import style0 from "./NewIndicator.vue?vue&type=style&index=0&id=ae43c43c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae43c43c",
  null
  
)

export default component.exports